"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_router_dom_1 = require("react-router-dom");
const browser_1 = require("@micro-sentry/browser");
const App_1 = __importDefault(require("./components/App"));
require("../../sass/webapp/styles.scss");
const StoreContext_1 = require("../common/StoreContext");
const services_1 = require("../common/services");
const polyfills_1 = __importDefault(require("../common/polyfills"));
const isLocalhost = window.location.hostname.includes('localhost');
let environment = 'production';
if (window.location.hostname.includes('experimental')) {
    environment = 'experimental';
}
else if (window.location.hostname.includes('staging')) {
    environment = 'staging';
}
Promise.all(polyfills_1.default)
    .then(() => {
    const rootNode = document.getElementById('webapp');
    const store = (0, services_1.createStore)();
    const client = new browser_1.BrowserMicroSentryClient({
        dsn: 'https://b4d4db11c3d04c518047fb425e5b7d2d@sentry.promptus-partners.de/10',
        release: '1.26',
        environment,
    });
    const reactApp = (react_1.default.createElement(StoreContext_1.StoreProviderComponent, { store: store },
        react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(App_1.default, null))));
    if (rootNode) {
        try {
            react_dom_1.default.render(reactApp, rootNode);
        }
        catch (e) {
            if (!isLocalhost) {
                client.report(e);
            }
        }
    }
})
    .catch(error => {
    console.error('Failed fetching polyfills', error);
});
